export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined || Number.isNaN(Number(seconds))) {
    return "—";
  }
  const s = Math.round(Number(seconds));
  if (s < 60) return `${s}s`;
  const minutes = Math.floor(s / 60);
  const remain = s % 60;
  if (minutes < 60) {
    return remain === 0 ? `${minutes}m` : `${minutes}m ${remain}s`;
  }
  const hours = Math.floor(minutes / 60);
  const mm = minutes % 60;
  return mm === 0 ? `${hours}h` : `${hours}h ${mm}m`;
};

export const formatNumber = (n) => {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("vi-VN").format(n);
};

export const formatPercent = (part, total, digits = 0) => {
  if (!total) return "0%";
  return `${((Number(part) / Number(total)) * 100).toFixed(digits)}%`;
};

export const formatDateShort = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit" });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const PRESET_RANGES = [
  { key: "today", label: "Hôm nay" },
  { key: "yesterday", label: "Hôm qua" },
  { key: "7d", label: "7 ngày" },
  { key: "30d", label: "30 ngày" },
  { key: "custom", label: "Tuỳ chọn" },
];

export const DEFAULT_RANGE_KEY = "7d";

const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

const endOfDay = (d) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

export const toInputDate = (d) => {
  if (!d) return "";
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const resolveRange = (key, { customFrom, customTo } = {}) => {
  const now = new Date();

  if (key === "today") {
    return { from: startOfDay(now).toISOString(), to: endOfDay(now).toISOString() };
  }
  if (key === "yesterday") {
    const y = new Date(now);
    y.setDate(y.getDate() - 1);
    return { from: startOfDay(y).toISOString(), to: endOfDay(y).toISOString() };
  }
  if (key === "30d") {
    const start = new Date(now);
    start.setDate(start.getDate() - 29);
    return { from: startOfDay(start).toISOString(), to: endOfDay(now).toISOString() };
  }
  if (key === "custom") {
    if (!customFrom || !customTo) return null;
    const fromD = new Date(customFrom);
    const toD = new Date(customTo);
    if (Number.isNaN(fromD.getTime()) || Number.isNaN(toD.getTime())) return null;
    if (fromD > toD) return null;
    return { from: startOfDay(fromD).toISOString(), to: endOfDay(toD).toISOString() };
  }
  // 7d default
  const start = new Date(now);
  start.setDate(start.getDate() - 6);
  return { from: startOfDay(start).toISOString(), to: endOfDay(now).toISOString() };
};
